import { CustomApiError } from "~utils/customApiError"

export interface ApiError {
  status: number
  // Backend error code string (e.g. "ALREADY_BEING_VALIDATED"), when present.
  code?: string
}

// The app's response interceptor only rejects 401/403/500 (mapped to a
// CustomApiError). Every other failing status RESOLVES the Api.* promise with
// the raw axios error object instead of throwing (see handleApiErrorMessage),
// so a 4xx can arrive either as a resolved value or as a thrown error depending
// on the status. This normalises all the shapes we may see — resolved axios
// error, thrown CustomApiError, thrown axios/network error — into { status, code }.
// Returns null for a genuine success response so callers can branch on it.
export const asApiError = (value: any): ApiError | null => {
  if (!value) return null

  if (value instanceof CustomApiError) {
    return { status: value.statusCode }
  }

  if (value.isAxiosError) {
    return {
      status: value.response?.status ?? 0,
      code: value.response?.data?.code,
    }
  }

  // Defensive: an object already carrying an error status (e.g. a response or a
  // previously-normalised ApiError).
  const status = value.response?.status ?? value.status
  if (typeof status === "number" && status >= 400) {
    return {
      status,
      code: value.response?.data?.code ?? value.data?.code ?? value.code,
    }
  }

  return null
}
